import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { DateRange, DateRangePicker } from '@mui/x-date-pickers-pro';
import { SxProps, styled } from '@mui/material/styles';
import './TwDateRange.scss';
interface TwDateRangePickerProps {
  /** Text that goes over the text field box. */
  label?: string;
  /** Classname for the text field. */
  textFieldClassName?: string;
  /** Classname for the container. */
  containerClassName?: string;
  /** Sx element for the container. */
  containerSx?: SxProps;
  /** Controls the popup or dialog open state */
  open?: boolean;
  /** Value of the datepicker. */
  value: DateRange<Date | null>;
  /** Datepicker change event. */
  onChange: (dateRange: DateRange<Date | null>) => void;
}

const StyledDateRangeLabel = styled('label')({
  color: '#7e858e',
  display: 'inline-block',
  fontSize: '14px',
  padding: '4px 0px',
  fontWeight: 400
});

const TwDateRangePicker: FC<TwDateRangePickerProps> = ({
  label,
  textFieldClassName,
  containerClassName,
  containerSx,
  open,
  value,
  onChange
}) => {
  return (
    <Box className={containerClassName} sx={containerSx}>
      {!!label && (
        <StyledDateRangeLabel>
          <span>{label}</span>
        </StyledDateRangeLabel>
      )}
      <DateRangePicker
        open={open}
        value={value}
        onChange={(newValue: any): void => onChange(newValue)}
        slotProps={{
          textField: { className: `tw-date-range-picker ${textFieldClassName}` },
          fieldSeparator: { children: 'to' }
        }}
      />
    </Box>
  );
};

export default TwDateRangePicker;
